import { useHeader } from '@contexts/header';
import { useDimensions } from '@hooks/useDimensions';
import type { IListTreatmentCategoriesOutputDTO } from '@services/treatments/dtos/listCategories/IOutputData';
import { treatmentService } from '@services/treatments/TreatmentService';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Link } from 'react-router';

export function TreatmentCategories() {
  const { data } = useSuspenseQuery<IListTreatmentCategoriesOutputDTO>({
    queryFn: async () => {
      const response = await treatmentService.listCategories();
      return response;
    },
    queryKey: ['treatment-categories'],
    refetchOnWindowFocus: false,
  });

  const { width } = useDimensions();
  const { onSetBackTitle } = useHeader();

  return (
    <div>
      <h1 className="text-primary text-2xl font-medium">Grandes áreas</h1>
      {width >= 1024 && (
        <div className="mt-4 flex flex-row flex-wrap justify-center gap-8">
          {data.list.map((item) => (
            <Link
              className="gradient-background bg-background text-background shadow-foreground/50 hover:shadow-foreground/60 nth-1:basis-[calc((100%/3)-1.34rem)] nth-2:basis-[calc((100%/3)-1.34rem)] nth-3:basis-[calc((100%/3)-1.34rem)] nth-4:basis-[calc(100%/3)] nth-5:basis-[calc(100%/3)] flex items-center justify-center gap-2 rounded-lg p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
              key={item.id}
              onClick={() => onSetBackTitle(item.title)}
              to={`/temas/${item.id}?name=${item.title}`}>
              {item.title}
            </Link>
          ))}
        </div>
      )}
      {width < 1024 && width >= 640 && (
        <div className="mt-4 flex flex-row flex-wrap justify-center gap-8">
          {data.list.slice(0, 3).map((item) => (
            <Link
              className="gradient-background bg-background text-background shadow-foreground/50 hover:shadow-foreground/60 nth-1:basis-[calc((100%/3)-1.34rem)] nth-2:basis-[calc((100%/3)-1.34rem)] nth-3:basis-[calc((100%/3)-1.34rem)] nth-4:basis-[calc(100%/3)] nth-5:basis-[calc(100%/3)] flex items-center justify-center gap-2 rounded-lg p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
              key={item.id}
              onClick={() => onSetBackTitle(item.title)}
              to={`/temas/${item.id}?name=${item.title}`}>
              {item.title}
            </Link>
          ))}
          {data.list.slice(3).map((item) => (
            <Link
              className="gradient-background bg-background text-background shadow-foreground/50 hover:shadow-foreground/60 nth-1:basis-[calc((100%/3)-1.34rem)] nth-2:basis-[calc((100%/3)-1.34rem)] nth-3:basis-[calc((100%/3)-1.34rem)] nth-4:basis-[calc(100%/3)] nth-5:basis-[calc(100%/3)] flex flex-1 items-center justify-center gap-2 rounded-lg p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
              key={item.id}
              onClick={() => onSetBackTitle(item.title)}
              to={`/temas/${item.id}?name=${item.title}`}>
              {item.title}
            </Link>
          ))}
        </div>
      )}
      {width < 640 && (
        <div className="mt-4 flex flex-col gap-8">
          {data.list.map((item) => (
            <Link
              className="gradient-background bg-background text-background shadow-foreground/50 hover:shadow-foreground/60 nth-1:basis-[calc((100%/3)-1.34rem)] nth-2:basis-[calc((100%/3)-1.34rem)] nth-3:basis-[calc((100%/3)-1.34rem)] nth-4:basis-[calc(100%/3)] nth-5:basis-[calc(100%/3)] flex items-center justify-center gap-2 rounded-lg p-3 text-base font-bold shadow-md transition-all duration-300 hover:scale-[1.02] lg:p-5 lg:text-lg"
              key={item.id}
              onClick={() => onSetBackTitle(item.title)}
              to={`/temas/${item.id}?name=${item.title}`}>
              {item.title}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
